module.exports = __webpack_public_path__ + "static/img/6.e8b5c13.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/eng/6.png
// module id = Tfd7
// module chunks = 0